import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/main.css';
import { ChakraProvider, extendTheme, ColorModeScript } from '@chakra-ui/react';

const config = {
  initialColorMode: 'system',
  useSystemColorMode: true,
};

const theme = extendTheme({ config });

// Resolve the three-state preference before React renders. This prevents a
// light/dark flash while still letting first-time visitors follow their device.
try {
  const preference = window.localStorage.getItem('iland.theme-preference');
  const followsSystem = preference !== 'light' && preference !== 'dark';
  const systemColorMode = window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
  const resolvedColorMode = followsSystem ? systemColorMode : preference;

  window.localStorage.setItem('chakra-ui-color-mode', resolvedColorMode);
} catch {
  // Storage can be unavailable in privacy modes; ColorModeScript still uses
  // the system preference as its fallback.
}


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <App />
    </ChakraProvider>
  </React.StrictMode>
);


reportWebVitals();
